import React, {useState} from 'react';
import {user} from "../../../models/user";
import {ApiService} from "../../../service/ApiService";

type UserPasswordGenerateProps = {
  user: user,
  className?: string,
  label?: string,
  generated?: () => void,
}

export const UserPasswordGenerate = ({user, className, label, generated}: UserPasswordGenerateProps) => {
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState(undefined as undefined | string);
  const [copied, setCopied] = useState(false);

  const generate = async () => {
    try {
      setLoading(true);
      const r = await ApiService.post(`/user/${user.userId}/password`) as { password: string };
      setPassword(r.password);
      setCopied(false);
    } catch (e) {
      alert("Une erreur c'est produite.");
      setConfirm(false);
    } finally {
      setLoading(false);
    }
  }

  const copy = async () => {
    if (password) {
      await navigator.clipboard.writeText(password);
      setCopied(true);
    }
  }

  const close = () => {
    const done = password !== undefined;

    setConfirm(false);
    setPassword(undefined);

    if (done && generated) {
      generated();
    }
  }

  return (
    <>
      <button className={className ?? 'btn btn-sm btn-warning'} type="button" onClick={() => setConfirm(true)}>
        <i className="fa-solid fa-key me-1"/>{label ?? 'Générer un mot de passe provisoire'}
      </button>

      {confirm && (
        <div className="__modal_container__ d-flex justify-content-center align-items-center">
          <div className="__modal_background__"/>
          <div className="__modal_box__ __front_box__ max-w70 max-h80 text-start">
            <div>
              <h2 className="__front_info_title__ m-0">Mot de passe provisoire</h2>
              <hr className="w-50 ms-auto me-auto mt-3 mb-4"/>
            </div>

            {!password && (
              <>
                <div>
                  Générer un mot de passe provisoire pour « {user.username} » ?<br/>
                  L'ancien mot de passe ne fonctionnera plus.
                </div>

                <p className="m-0 mt-5 text-end">
                  <button className="btn btn-sm btn-warning me-1" onClick={generate} disabled={loading}>
                    Générer
                    {loading && (
                      <span className="ms-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    )}
                  </button>
                  <button className="btn btn-sm btn-info" onClick={close} disabled={loading}>Annuler</button>
                </p>
              </>
            )}

            {password && (
              <>
                <p className="mb-2">
                  Mot de passe provisoire de « {user.username} » à transmettre (il ne sera plus affiché) :
                </p>
                <div className="input-group">
                  <input type="text" className="form-control font-monospace" value={password} readOnly/>
                  <button className="btn btn-sm btn-primary" type="button" onClick={copy}>
                    <i className={`fa-solid ${copied ? 'fa-check' : 'fa-copy'} me-1`}/>{copied ? 'copié' : 'copier'}
                  </button>
                </div>
                <p className="mt-2 mb-0 small">L'utilisateur devra le modifier à sa première connexion.</p>

                <p className="m-0 mt-5 text-end">
                  <button className="btn btn-sm btn-info" onClick={close}>Fermer</button>
                </p>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
